import { useMyInfo } from '../queries';
import { useMemo } from 'react';

export const useIsAnonymousUser = () => {
  const { data: myInfo } = useMyInfo();

  return useMemo(() => myInfo.is_anonymous, [myInfo]);
};
